import React from 'react';
import {
  Button,
  Typography,
  TextField,
  CircularProgress
} from '@mui/material';
import { ContentCopy as DuplicateIcon } from '@mui/icons-material';
import BaseDialog from '../common/BaseDialog';

interface DuplicateJobDialogProps {
  open: boolean;
  onClose: () => void;
  onDuplicate: () => void;
  duplicateAddress: string;
  onAddressChange: (address: string) => void;
  isDuplicating: boolean;
}

const DuplicateJobDialog: React.FC<DuplicateJobDialogProps> = ({
  open,
  onClose,
  onDuplicate,
  duplicateAddress,
  onAddressChange,
  isDuplicating
}) => {
  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title="Duplicate Job"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: { xs: 'calc(100vw - 10px)', sm: '500px' }
        }
      }}
      contentSx={{ pb: 2 }}
      actions={
        <>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            disabled={isDuplicating}
          >
            Cancel
          </Button>
          <Button
            onClick={onDuplicate}
            variant="contained"
            disabled={isDuplicating}
            startIcon={isDuplicating ? <CircularProgress size={20} /> : <DuplicateIcon />}
          >
            {isDuplicating ? 'Duplicating...' : 'Duplicate'}
          </Button>
        </>
      }
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        This will create a copy of the job with a new job number. All form responses will be copied, but communications and documents will not be included.
      </Typography>
      <TextField
        fullWidth
        label="Job Address"
        value={duplicateAddress}
        onChange={(e) => onAddressChange(e.target.value)}
        multiline
        rows={3}
        placeholder="Enter the job address for the new job"
        helperText="You can modify the address for the duplicated job"
      />
    </BaseDialog>
  );
};

export default DuplicateJobDialog;
